// Single source of truth for the Auto Tune settings drawer width, shared by
// the jobs and cluster drawers (and any future surface, e.g. SQL Warehouses)
// so the drawer ratio stays consistent everywhere.
//
// `min(80vw, 1500px)` leaves the page visibly behind the drawer even on a
// 1280-1440px laptop (95vw read as a full-page takeover there) while still
// giving the task DAG room, and caps at 1500px so wide monitors don't render
// an absurdly wide drawer. No breakpoint logic — the `min()` clamp scales
// smoothly.
export const AUTO_TUNE_DRAWER_WIDTH_CLASS = "!al-w-[min(80vw,1500px)] !al-max-w-none";
